<template>
    <div>
 <header class="header">
                <img v-if="languageIndex == 0" src="static/img/banner2.png" alt="">
                <img v-else src="static/img/banner22.png" alt="">
                <navHeader ref=navHeader></navHeader>
        </header>
        <main class="main">
            <h2>{{langtrans().lxjfs[languageIndex]}}</h2>
            <ul>
                <li>
                    <img src="static/img/icon_01.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().ddjxzb[languageIndex]}}</h3>
                        <p>{{langtrans().ddzbjs[languageIndex]}}</p>
                        <p>{{langtrans().dh[languageIndex]}}（010）68188889</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/icon_02.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().bxdcsw[languageIndex]}}</h3>
                        <p>{{langtrans().dh[languageIndex]}}（010）68188889</p>
                        <p>{{langtrans().yx[languageIndex]}}jiuyuan@jiangtai.com</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/icon_03.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().ffwsjm[languageIndex]}}</h3>
                        <p><span @click="league()" class="pointer_box">{{langtrans().lmmjs[languageIndex]}} </span><span @click="league()" class="pointer_box">{{langtrans().sqjmm[languageIndex]}}</span></p>
                    </div>
                </li>
                <li>
                    <img src="static/img/icon_04.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().xsssq[languageIndex]}}</h3>
                        <p><span class="pointer_box" @click="stars()">{{langtrans().cwwxss[languageIndex]}}</span></p>
                    </div>
                </li>
                <li>
                    <img src="static/img/icon_05.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().bajyqz[languageIndex]}}</h3>
                        <p>{{langtrans().dh[languageIndex]}}（010）68189191</p>
                    </div>
                </li>
                <li>
                    <img src="static/img/icon_06.png" alt="">
                    <div class="list_box">
                        <h3>{{langtrans().yjxjyf[languageIndex]}}</h3>
                        <p><span @click="feedback()" class="pointer_box">{{langtrans().yjxfk[languageIndex]}}</span></p>
                    </div>
                </li>
            </ul>
        </main>
        <vFooter @performHeader=performHeader></vFooter>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/contact.vue.trans.js";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import navHeader from '@/components/header/indexHeader'
import vFooter from '@/components/footer/indexFooter'
export default {
  data() {
    return {
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  components:{
  	navHeader,
  	vFooter
  },  
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
  methods: {
		langtrans(){
			return langtrans
		},	
  	performHeader(str){
    	this.$refs.navHeader.login(str)
    },
        stars(){
      this.$router.push({
        name: "stars"
      });
    },
    league() {
      this.$router.push({
        name: "league"
      });
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    },

    }
};
</script>

<style scoped>
@import url(../../static/css/global.css);
h3,
p {
  text-align: start;
}
.main {
  display: block;
  padding: 7.45vw 15vw 6vw 21vw;
}
.main h2 {
  font-size: 1.625vw;
  margin-left: 1.25vw;
  color: #333;
}
.main ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.main ul li {
  width: 40%;
  display: flex;
  padding: 1.875vw 0.9375vw;
}
.main ul li img {
  width: 3.75vw;
  height: 3.75vw;
}
.main ul li .list_box {
  margin-left: 0.9375vw;
}
.main ul li .list_box h3 {
  font-size: 1.25vw;
  color: #333;
  line-height: 3.75vw;
}
.main ul li .list_box p {
  color: #666;
  font-size: 1.1vw;
  margin-top: 0.3125vw;
}
.main ul li .list_box p + p {
  margin-top: 0.6vw;
}
.main ul li .list_box p span {
  color: #ff860f;
  text-decoration: underline;
  text-decoration-color: #ff860f;
}
.main ul li .list_box p span + span {
  margin-left: 2.1875vw;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue